// src/data/countryCodes.js
// 全球國際電話國碼資料（ISO 3166-1 alpha-2）
//
// 每筆格式：[iso, dial, 中文名稱, 英文名稱, trunkZero]
//   trunkZero = 1 代表該國本地撥號習慣在前面加 0（中繼碼），轉 E.164 時要去掉。
//   不確定或本來就沒有中繼碼的國家一律給 0，維持使用者輸入原樣（例如義大利市話的 0 是號碼本體）。

const RAW = [
  // 東亞／東南亞
  ['TW', '886', '台灣', 'Taiwan', 1],
  ['JP', '81', '日本', 'Japan', 1],
  ['KR', '82', '韓國', 'South Korea', 1],
  ['CN', '86', '中國', 'China', 1],
  ['HK', '852', '香港', 'Hong Kong', 0],
  ['MO', '853', '澳門', 'Macau', 0],
  ['SG', '65', '新加坡', 'Singapore', 0],
  ['MY', '60', '馬來西亞', 'Malaysia', 1],
  ['TH', '66', '泰國', 'Thailand', 1],
  ['VN', '84', '越南', 'Vietnam', 1],
  ['PH', '63', '菲律賓', 'Philippines', 1],
  ['ID', '62', '印尼', 'Indonesia', 1],
  ['BN', '673', '汶萊', 'Brunei', 0],
  ['KH', '855', '柬埔寨', 'Cambodia', 1],
  ['LA', '856', '寮國', 'Laos', 1],
  ['MM', '95', '緬甸', 'Myanmar', 1],
  ['MN', '976', '蒙古', 'Mongolia', 0],
  ['KP', '850', '北韓', 'North Korea', 0],
  ['TL', '670', '東帝汶', 'Timor-Leste', 0],

  // 南亞／中亞
  ['IN', '91', '印度', 'India', 1],
  ['PK', '92', '巴基斯坦', 'Pakistan', 1],
  ['BD', '880', '孟加拉', 'Bangladesh', 1],
  ['LK', '94', '斯里蘭卡', 'Sri Lanka', 1],
  ['NP', '977', '尼泊爾', 'Nepal', 0],
  ['BT', '975', '不丹', 'Bhutan', 0],
  ['MV', '960', '馬爾地夫', 'Maldives', 0],
  ['AF', '93', '阿富汗', 'Afghanistan', 1],
  ['KZ', '7', '哈薩克', 'Kazakhstan', 0],
  ['UZ', '998', '烏茲別克', 'Uzbekistan', 1],
  ['KG', '996', '吉爾吉斯', 'Kyrgyzstan', 0],
  ['TJ', '992', '塔吉克', 'Tajikistan', 0],
  ['TM', '993', '土庫曼', 'Turkmenistan', 1],

  // 中東
  ['AE', '971', '阿拉伯聯合大公國', 'United Arab Emirates', 1],
  ['SA', '966', '沙烏地阿拉伯', 'Saudi Arabia', 1],
  ['IL', '972', '以色列', 'Israel', 1],
  ['TR', '90', '土耳其', 'Turkey', 1],
  ['IR', '98', '伊朗', 'Iran', 1],
  ['IQ', '964', '伊拉克', 'Iraq', 1],
  ['JO', '962', '約旦', 'Jordan', 1],
  ['LB', '961', '黎巴嫩', 'Lebanon', 1],
  ['KW', '965', '科威特', 'Kuwait', 0],
  ['QA', '974', '卡達', 'Qatar', 0],
  ['BH', '973', '巴林', 'Bahrain', 0],
  ['OM', '968', '阿曼', 'Oman', 0],
  ['YE', '967', '葉門', 'Yemen', 1],
  ['SY', '963', '敘利亞', 'Syria', 1],
  ['PS', '970', '巴勒斯坦', 'Palestine', 1],
  ['GE', '995', '喬治亞', 'Georgia', 1],
  ['AM', '374', '亞美尼亞', 'Armenia', 1],
  ['AZ', '994', '亞塞拜然', 'Azerbaijan', 1],
  ['CY', '357', '賽普勒斯', 'Cyprus', 0],

  // 歐洲
  ['GB', '44', '英國', 'United Kingdom', 1],
  ['IE', '353', '愛爾蘭', 'Ireland', 1],
  ['FR', '33', '法國', 'France', 1],
  ['DE', '49', '德國', 'Germany', 1],
  ['NL', '31', '荷蘭', 'Netherlands', 1],
  ['BE', '32', '比利時', 'Belgium', 1],
  ['LU', '352', '盧森堡', 'Luxembourg', 0],
  ['CH', '41', '瑞士', 'Switzerland', 1],
  ['AT', '43', '奧地利', 'Austria', 1],
  ['IT', '39', '義大利', 'Italy', 0],
  ['ES', '34', '西班牙', 'Spain', 0],
  ['PT', '351', '葡萄牙', 'Portugal', 0],
  ['GR', '30', '希臘', 'Greece', 0],
  ['SE', '46', '瑞典', 'Sweden', 1],
  ['NO', '47', '挪威', 'Norway', 0],
  ['DK', '45', '丹麥', 'Denmark', 0],
  ['FI', '358', '芬蘭', 'Finland', 1],
  ['IS', '354', '冰島', 'Iceland', 0],
  ['PL', '48', '波蘭', 'Poland', 0],
  ['CZ', '420', '捷克', 'Czechia', 0],
  ['SK', '421', '斯洛伐克', 'Slovakia', 0],
  ['HU', '36', '匈牙利', 'Hungary', 1],
  ['RO', '40', '羅馬尼亞', 'Romania', 1],
  ['BG', '359', '保加利亞', 'Bulgaria', 1],
  ['HR', '385', '克羅埃西亞', 'Croatia', 1],
  ['SI', '386', '斯洛維尼亞', 'Slovenia', 1],
  ['RS', '381', '塞爾維亞', 'Serbia', 1],
  ['BA', '387', '波士尼亞與赫塞哥維納', 'Bosnia and Herzegovina', 1],
  ['ME', '382', '蒙特內哥羅', 'Montenegro', 1],
  ['MK', '389', '北馬其頓', 'North Macedonia', 1],
  ['AL', '355', '阿爾巴尼亞', 'Albania', 1],
  ['EE', '372', '愛沙尼亞', 'Estonia', 0],
  ['LV', '371', '拉脫維亞', 'Latvia', 0],
  ['LT', '370', '立陶宛', 'Lithuania', 1],
  ['BY', '375', '白俄羅斯', 'Belarus', 1],
  ['UA', '380', '烏克蘭', 'Ukraine', 1],
  ['RU', '7', '俄羅斯', 'Russia', 0],
  ['MD', '373', '摩爾多瓦', 'Moldova', 1],
  ['MT', '356', '馬爾他', 'Malta', 0],
  ['MC', '377', '摩納哥', 'Monaco', 0],
  ['AD', '376', '安道爾', 'Andorra', 0],
  ['SM', '378', '聖馬利諾', 'San Marino', 0],
  ['LI', '423', '列支敦斯登', 'Liechtenstein', 0],
  ['GI', '350', '直布羅陀', 'Gibraltar', 0],
  ['FO', '298', '法羅群島', 'Faroe Islands', 0],
  ['GL', '299', '格陵蘭', 'Greenland', 0],
  ['JE', '44', '澤西島', 'Jersey', 1],
  ['GG', '44', '根息島', 'Guernsey', 1],
  ['IM', '44', '曼島', 'Isle of Man', 1],

  // 美洲
  ['US', '1', '美國', 'United States', 0],
  ['CA', '1', '加拿大', 'Canada', 0],
  ['MX', '52', '墨西哥', 'Mexico', 0],
  ['BR', '55', '巴西', 'Brazil', 1],
  ['AR', '54', '阿根廷', 'Argentina', 1],
  ['CL', '56', '智利', 'Chile', 0],
  ['CO', '57', '哥倫比亞', 'Colombia', 0],
  ['PE', '51', '秘魯', 'Peru', 0],
  ['VE', '58', '委內瑞拉', 'Venezuela', 0],
  ['EC', '593', '厄瓜多', 'Ecuador', 1],
  ['BO', '591', '玻利維亞', 'Bolivia', 0],
  ['PY', '595', '巴拉圭', 'Paraguay', 1],
  ['UY', '598', '烏拉圭', 'Uruguay', 0],
  ['GY', '592', '蓋亞那', 'Guyana', 0],
  ['SR', '597', '蘇利南', 'Suriname', 0],
  ['GT', '502', '瓜地馬拉', 'Guatemala', 0],
  ['CR', '506', '哥斯大黎加', 'Costa Rica', 0],
  ['PA', '507', '巴拿馬', 'Panama', 0],
  ['HN', '504', '宏都拉斯', 'Honduras', 0],
  ['SV', '503', '薩爾瓦多', 'El Salvador', 0],
  ['NI', '505', '尼加拉瓜', 'Nicaragua', 0],
  ['BZ', '501', '貝里斯', 'Belize', 0],
  ['CU', '53', '古巴', 'Cuba', 0],
  ['HT', '509', '海地', 'Haiti', 0],
  ['DO', '1', '多明尼加', 'Dominican Republic', 0],
  ['PR', '1', '波多黎各', 'Puerto Rico', 0],
  ['JM', '1', '牙買加', 'Jamaica', 0],
  ['TT', '1', '千里達及托巴哥', 'Trinidad and Tobago', 0],
  ['BS', '1', '巴哈馬', 'Bahamas', 0],
  ['BB', '1', '巴貝多', 'Barbados', 0],
  ['GP', '590', '瓜地洛普', 'Guadeloupe', 0],
  ['MQ', '596', '馬丁尼克', 'Martinique', 0],

  // 大洋洲
  ['AU', '61', '澳洲', 'Australia', 1],
  ['NZ', '64', '紐西蘭', 'New Zealand', 1],
  ['FJ', '679', '斐濟', 'Fiji', 0],
  ['PG', '675', '巴布亞紐幾內亞', 'Papua New Guinea', 0],
  ['NC', '687', '新喀里多尼亞', 'New Caledonia', 0],
  ['PF', '689', '法屬玻里尼西亞', 'French Polynesia', 0],
  ['SB', '677', '索羅門群島', 'Solomon Islands', 0],
  ['VU', '678', '瓦努阿圖', 'Vanuatu', 0],
  ['WS', '685', '薩摩亞', 'Samoa', 0],
  ['TO', '676', '東加', 'Tonga', 0],
  ['GU', '1', '關島', 'Guam', 0],
  ['PW', '680', '帛琉', 'Palau', 0],
  ['FM', '691', '密克羅尼西亞', 'Micronesia', 0],
  ['MH', '692', '馬紹爾群島', 'Marshall Islands', 0],
  ['KI', '686', '吉里巴斯', 'Kiribati', 0],
  ['NR', '674', '諾魯', 'Nauru', 0],
  ['TV', '688', '吐瓦魯', 'Tuvalu', 0],
  ['CK', '682', '庫克群島', 'Cook Islands', 0],
  ['NU', '683', '紐埃', 'Niue', 0],

  // 非洲
  ['ZA', '27', '南非', 'South Africa', 1],
  ['EG', '20', '埃及', 'Egypt', 1],
  ['NG', '234', '奈及利亞', 'Nigeria', 1],
  ['KE', '254', '肯亞', 'Kenya', 1],
  ['MA', '212', '摩洛哥', 'Morocco', 1],
  ['DZ', '213', '阿爾及利亞', 'Algeria', 1],
  ['TN', '216', '突尼西亞', 'Tunisia', 0],
  ['LY', '218', '利比亞', 'Libya', 1],
  ['SD', '249', '蘇丹', 'Sudan', 1],
  ['SS', '211', '南蘇丹', 'South Sudan', 1],
  ['ET', '251', '衣索比亞', 'Ethiopia', 1],
  ['ER', '291', '厄利垂亞', 'Eritrea', 1],
  ['GH', '233', '迦納', 'Ghana', 1],
  ['TZ', '255', '坦尚尼亞', 'Tanzania', 1],
  ['UG', '256', '烏干達', 'Uganda', 1],
  ['ZW', '263', '辛巴威', 'Zimbabwe', 1],
  ['ZM', '260', '尚比亞', 'Zambia', 1],
  ['MW', '265', '馬拉威', 'Malawi', 1],
  ['MZ', '258', '莫三比克', 'Mozambique', 0],
  ['AO', '244', '安哥拉', 'Angola', 0],
  ['NA', '264', '納米比亞', 'Namibia', 1],
  ['BW', '267', '波札那', 'Botswana', 0],
  ['LS', '266', '賴索托', 'Lesotho', 0],
  ['SZ', '268', '史瓦帝尼', 'Eswatini', 0],
  ['MG', '261', '馬達加斯加', 'Madagascar', 1],
  ['MU', '230', '模里西斯', 'Mauritius', 0],
  ['SC', '248', '塞席爾', 'Seychelles', 0],
  ['KM', '269', '葛摩', 'Comoros', 0],
  ['RE', '262', '留尼旺', 'Réunion', 0],
  ['CM', '237', '喀麥隆', 'Cameroon', 0],
  ['CI', '225', '象牙海岸', "Côte d'Ivoire", 0],
  ['SN', '221', '塞內加爾', 'Senegal', 0],
  ['ML', '223', '馬利', 'Mali', 0],
  ['BF', '226', '布吉納法索', 'Burkina Faso', 0],
  ['NE', '227', '尼日', 'Niger', 0],
  ['TD', '235', '查德', 'Chad', 0],
  ['CF', '236', '中非共和國', 'Central African Republic', 0],
  ['CG', '242', '剛果共和國', 'Republic of the Congo', 0],
  ['CD', '243', '剛果民主共和國', 'DR Congo', 0],
  ['GA', '241', '加彭', 'Gabon', 0],
  ['GQ', '240', '赤道幾內亞', 'Equatorial Guinea', 0],
  ['BJ', '229', '貝南', 'Benin', 0],
  ['TG', '228', '多哥', 'Togo', 0],
  ['LR', '231', '賴比瑞亞', 'Liberia', 0],
  ['SL', '232', '獅子山', 'Sierra Leone', 0],
  ['GN', '224', '幾內亞', 'Guinea', 0],
  ['GW', '245', '幾內亞比索', 'Guinea-Bissau', 0],
  ['GM', '220', '甘比亞', 'Gambia', 0],
  ['MR', '222', '茅利塔尼亞', 'Mauritania', 0],
  ['CV', '238', '維德角', 'Cape Verde', 0],
  ['ST', '239', '聖多美普林西比', 'São Tomé and Príncipe', 0],
  ['RW', '250', '盧安達', 'Rwanda', 0],
  ['BI', '257', '蒲隆地', 'Burundi', 0],
  ['SO', '252', '索馬利亞', 'Somalia', 0],
  ['DJ', '253', '吉布地', 'Djibouti', 0],
];

/** 置頂的常用國家（依此順序顯示在清單最前面） */
export const POPULAR_ISO = ['TW', 'JP', 'KR', 'CN', 'HK', 'MO', 'US', 'CA', 'GB', 'AU', 'SG', 'MY', 'TH', 'VN', 'PH', 'ID'];

/** ISO alpha-2 → 國旗 emoji（區域指示符號） */
export function flagOf(iso) {
  const s = String(iso || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(s)) return '🏳️';
  return String.fromCodePoint(...[...s].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
}

export const COUNTRIES = RAW.map(([iso, dial, name, nameEn, trunkZero]) => ({
  iso,
  dial,
  name,
  nameEn,
  trunkZero: !!trunkZero,
  flag: flagOf(iso),
  search: `${iso} ${dial} +${dial} ${name} ${nameEn}`.toLowerCase(),
}));

const BY_ISO = new Map(COUNTRIES.map((c) => [c.iso, c]));

/**
 * 同一國碼可能對應多國（+1 有 NANP 多國、+44 有英國與屬地、+7 有俄羅斯與哈薩克）。
 * 由號碼反推國家時需要一個代表國，這裡明確指定，不依賴 RAW 的排列順序。
 */
const PRIMARY_OVERRIDE = { 1: 'US', 7: 'RU', 44: 'GB' };

const PRIMARY_BY_DIAL = new Map();
COUNTRIES.forEach((c) => {
  const forced = PRIMARY_OVERRIDE[c.dial];
  if (forced && forced !== c.iso) return;
  if (!PRIMARY_BY_DIAL.has(c.dial)) PRIMARY_BY_DIAL.set(c.dial, c);
});

/** 顯示順序：常用置頂，其餘依該語系的國名排序 */
const popularRank = new Map(POPULAR_ISO.map((iso, i) => [iso, i]));
const sortBy = (locale, nameOf) => [...COUNTRIES].sort((a, b) => {
  const ra = popularRank.has(a.iso) ? popularRank.get(a.iso) : Infinity;
  const rb = popularRank.has(b.iso) ? popularRank.get(b.iso) : Infinity;
  if (ra !== rb) return ra - rb;
  return nameOf(a).localeCompare(nameOf(b), locale);
});

export const COUNTRIES_SORTED = sortBy('zh-Hant', (c) => c.name);
const COUNTRIES_SORTED_EN = sortBy('en', (c) => c.nameEn);

const isEn = (lang) => String(lang || '').toLowerCase().startsWith('en');

/** 依語系取國名；未指定語系時回傳中文 */
export function countryName(country, lang) {
  if (!country) return '';
  return isEn(lang) ? country.nameEn : country.name;
}

/** 依語系取得排序後的完整清單 */
export function countriesFor(lang) {
  return isEn(lang) ? COUNTRIES_SORTED_EN : COUNTRIES_SORTED;
}

export function findByIso(iso) {
  return BY_ISO.get(String(iso || '').toUpperCase()) || null;
}

export function primaryByDial(dial) {
  return PRIMARY_BY_DIAL.get(String(dial || '')) || null;
}

/** 由純數字字串做最長前綴比對，取出國碼（國碼最長 3 位） */
export function matchDial(digitsOnly) {
  const s = String(digitsOnly || '');
  for (let len = 3; len >= 1; len--) {
    const prefix = s.slice(0, len);
    if (PRIMARY_BY_DIAL.has(prefix)) return prefix;
  }
  return null;
}

/**
 * 搜尋：不分介面語系，中文、英文、ISO 代碼與國碼數字都可以打
 * （英文介面的使用者仍可能輸入中文國名，反之亦然）
 */
export function searchCountries(keyword, lang) {
  const base = countriesFor(lang);
  const q = String(keyword || '').trim().toLowerCase().replace(/^\+/, '');
  if (!q) return base;
  const starts = [];
  const contains = [];
  base.forEach((c) => {
    const idx = c.search.indexOf(q);
    if (idx < 0) return;
    if (c.name.toLowerCase().startsWith(q) || c.nameEn.toLowerCase().startsWith(q)
      || c.iso.toLowerCase().startsWith(q) || c.dial.startsWith(q)) starts.push(c);
    else contains.push(c);
  });
  return [...starts, ...contains];
}
